import { useMemo } from 'react';
import { ethers } from 'ethers';
import { useWeb3 } from '../context/Web3Context';
import { ADDR } from '../config/contracts';
import LogicAbi from '../abis/ZenovaLogic.json';
import AdminAbi from '../abis/ZenovaAdmin.json';
import StorageAbi from '../abis/ZenovaStorage.json';
import ViewsAbi from '../abis/ZenovaViews.json';
import Erc20Abi from '../abis/ERC20.json';
import { ACTIVE } from '../config/networks';

// Fallback read-only provider using the active network's RPC.
// Used when the wallet is not connected or on the wrong network.
const getReadonlyProvider = () => {
  try {
    return new ethers.providers.JsonRpcProvider(ACTIVE.rpcUrls[0], ACTIVE.chainId);
  } catch (e) {
    return null;
  }
};

export const useContracts = () => {
  const { signer, provider, rightNetwork } = useWeb3();

  return useMemo(() => {
    const readProvider = rightNetwork && provider ? provider : getReadonlyProvider();
    const writeSigner = rightNetwork ? signer : null;

    const mkContract = (address, abi, wantWrite = false) => {
      if (!address || address === ethers.constants.AddressZero) return null;
      if (wantWrite) {
        return writeSigner ? new ethers.Contract(address, abi, writeSigner) : null;
      }
      return readProvider ? new ethers.Contract(address, abi, readProvider) : null;
    };

    return {
      // read-only
      viewsR:   mkContract(ADDR.views,   ViewsAbi,   false),
      storageR: mkContract(ADDR.storage, StorageAbi, false),
      logicR:   mkContract(ADDR.logic,   LogicAbi,   false),
      adminR:   mkContract(ADDR.admin,   AdminAbi,   false),
      usdcR:    mkContract(ADDR.usdc,    Erc20Abi,   false),
      zenovaR:  mkContract(ADDR.zenova,  Erc20Abi,   false),

      // write (require signer + correct network)
      logicW:   mkContract(ADDR.logic,   LogicAbi,   true),
      adminW:   mkContract(ADDR.admin,   AdminAbi,   true),
      storageW: mkContract(ADDR.storage, StorageAbi, true),
      usdcW:    mkContract(ADDR.usdc,    Erc20Abi,   true),
      zenovaW:  mkContract(ADDR.zenova,  Erc20Abi,   true)
    };
  }, [signer, provider, rightNetwork]);
};
